import { Flex, Text } from '@backstage/ui';
import type { ReactNode } from 'react';

// "Label over value" field built only from BUI primitives. Put several in a
// <Flex direction="row"> to line their labels up on a shared top edge.
// Example: <CodespaceField label="Branch" value="main" />
export const CodespaceField = ({ label, value }: { label: string; value: ReactNode }) => (
  <Flex direction="column" gap="1">
    <Text variant="body-x-small" color="secondary" weight="bold">
      {label}
    </Text>
    {typeof value === 'string' ? <Text variant="body-medium">{value}</Text> : value}
  </Flex>
);
